import { useMemo } from "react";

import PrintableCheckboxField from "pages/PrintableChecklist/components/PrintableCheckboxField";
import PrintableDropdownfield from "pages/PrintableChecklist/components/PrintableDropdownField";
import PrintableField from "pages/PrintableChecklist/components/PrintableField";
import PrintableFileField from "pages/PrintableChecklist/components/PrintableFileField";
import PrintableFixedTableField from "pages/PrintableChecklist/components/PrintableFixedTable";
import PrintableFormTextField from "pages/PrintableChecklist/components/PrintableFormTextField";
import PrintableRadiobuttonfield from "pages/PrintableChecklist/components/PrintableRadioButtonField";
import PrintableRichtextfield from "pages/PrintableChecklist/components/PrintableRichTextField";
import PrintableTablefield from "pages/PrintableChecklist/components/PrintableTablefield";

import { FieldType } from "entities/Field/sdk";
import { convertPackageFieldToField } from "entities/Package/components/FieldWrapper/utils";
import { IPackageField } from "entities/Package/sdk";

export interface IPrintableFieldWrapper {
  field: IPackageField;
}

const PrintableFieldWrapper = ({
  field: propsField,
}: IPrintableFieldWrapper) => {
  const field = useMemo(
    () => convertPackageFieldToField({ field: propsField }),
    [propsField]
  );

  if (field.field_type === FieldType.TEXT_FIELD) {
    return <PrintableField field={field} />;
  }

  if (field.field_type === FieldType.DROPDOWN) {
    return <PrintableDropdownfield field={field} />;
  }

  if (field.field_type === FieldType.RADIO_BUTTON) {
    return <PrintableRadiobuttonfield field={field} />;
  }

  if (field.field_type === FieldType.CHECKBOX) {
    return <PrintableCheckboxField field={field} />;
  }

  if (field.field_type === FieldType.RICH_TEXT_FIELD) {
    return <PrintableRichtextfield field={field} />;
  }

  if (field.field_type === FieldType.TABLE) {
    return <PrintableTablefield field={field} />;
  }

  if (field.field_type === FieldType.FIXED_TABLE) {
    return <PrintableFixedTableField field={field} />;
  }

  if (field.field_type === FieldType.FORM_TEXT_FIELD) {
    return <PrintableFormTextField field={field} />;
  }
  if (field.field_type === FieldType.FILE) {
    return <PrintableFileField field={field} />;
  }

  return null;
};

export default PrintableFieldWrapper;
